import {combineReducers} from 'redux';
import Const from 'constants';
import {calcUserScore} from 'helpers/common-helper';
import {sortByProperty} from 'helpers/sorters';
import {createOverallFilterPosition} from 'components/organisms/filter-by-position/filter-position-interface';
import {createOverallFilterTier} from 'components/organisms/filter-by-tiers/filter-tier-interface';
import SubstitutePlayersConverter from 'services/sports/default/substitute-players-converter';

const defaultStateOfPlayersFilters = {
    games: [],
    playersType: Const.OVERALL_MODE,
    playerName: '',
    playerSalaryRange: {
        min: 0,
        max: 1000,
    },
    playerSalary: {
        min: 0,
        max: 1000,
    },
    captain_playerSalaryRange: {
        min: 0,
        max: 1000,
    },
    captain_playerSalary: {
        min: 0,
        max: 1000,
    },
    userPointsRange: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    userPoints: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    captain_userPointsRange: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    captain_userPoints: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    star_userPointsRange: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    star_userPoints: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    pro_userPointsRange: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    pro_userPoints: {
        min: Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
        max: 100,
    },
    playerPosition: createOverallFilterPosition(),
    playerConfirmed: Const.PLAYERS_CONFIRMED_FILTER_ALL,
    team: Const.PLAYERS_TEAM_FILTER_ALL,
    sort: Const.MOBILE_SORT_DEFAULT,
    isSortEqual(sort) {
        return this.sort === sort;
    },
    isModeLocked() {
        return Const.LOCKED_MODE === this.playersType;
    },
    isModeFlex() {
        return Const.FLEX_MODE === this.playersType;
    },
    isModeExcluded() {
        return Const.EXCLUDED_MODE === this.playersType;
    },
    isModeFavorite() {
        return Const.FAVORITE_MODE === this.playersType;
    },
    isModeOverall() {
        return Const.OVERALL_MODE === this.playersType;
    },
    isModeCaptain() {
        return Const.CAPTAIN_MODE === this.playersType;
    },
    isModeStar() {
        return Const.STAR_MODE === this.playersType;
    },
    isModePro() {
        return Const.PRO_MODE === this.playersType;
    },
};

export function filters(state = defaultStateOfPlayersFilters, action) {
    if (action.type === Const.SET_GAMES_FILTER) {
        state = {...state, games: action.data};
    } else if (action.type === Const.SET_PLAYER_POSITIONS_FILTER) {
        state = {...state, playerPosition: action.position};
    } else if (action.type === Const.SET_PLAYER_CONFIRMED_FILTER) {
        state = {...state, playerConfirmed: action.data};
    } else if (action.type === Const.FILTER_BY_PLAYER_SALARY_FILTER) {
        state = {...state, playerSalary: action.data};
    } else if (action.type === Const.FILTER_BY_CAPTION_SALARY_FILTER) {
        state = {...state, captain_playerSalary: action.data};
    } else if (action.type === Const.FILTER_BY_USER_POINTS_FILTER) {
        state = {...state, userPoints: action.data};
    } else if (action.type === Const.FILTER_BY_CAPTION_USER_POINTS_FILTER) {
        state = {...state, captain_userPoints: action.data};
    } else if (action.type === Const.FILTER_BY_STAR_USER_POINTS_FILTER) {
        state = {...state, star_userPoints: action.data};
    } else if (action.type === Const.FILTER_BY_PRO_USER_POINTS_FILTER) {
        state = {...state, pro_userPoints: action.data};
    } else if (action.type === Const.FILTER_BY_PLAYERS_TYPE) {
        state = {...state, playersType: action.playersType};
    } else if (action.type === Const.FILTER_BY_PLAYER_NAME) {
        state = {...state, playerName: action.name};
    } else if (action.type === Const.FILTER_BY_TEAM) {
        state = {...state, team: action.team};
    } else if (action.type === Const.SET_PLAYERS_SORT_BY) {
        state = {...state, sort: action.sort};
    } else if (
        inArray(action.type, [
            Const.FILTER_BY_MODE,
            Const.FILTER_BY_SITE,
            Const.FILTER_BY_SPORT,
            Const.FILTER_BY_GAME_TYPE,
            Const.FILTER_BY_SLATE,
            Const.RESET_ALL_SETTINGS,
        ])
    ) {
        state = {...defaultStateOfPlayersFilters};
    }

    return state;
}

const defaultStateOfMlbLineupsFilters = {
    order: {...Const.DEFAULT_VALUES_OF_LINEUPS_MLB_FILTER.order},
    getNotChosen() {
        return Object.keys(this.order)
            .filter((orderNumber) => !this.order[orderNumber])
            .map((orderNumber) => Number(orderNumber));
    },
};

export function mlbFilters(state = defaultStateOfMlbLineupsFilters, action) {
    state = {...state};

    if (action.type === Const.SET_HITTERS_ORDER) {
        state.order = action.order;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state.order = defaultStateOfMlbLineupsFilters.order;
    }

    return state;
}

const defaultStateOfLineGroupFilter = {
    lineGroups: {...Const.DEFAULT_VALUES_OF_LINE_GROUPING_NHL_FILTER},
    getNotChosen() {
        return Object.keys(this.lineGroups)
            .filter((groupNumber) => !this.lineGroups[groupNumber])
            .map((groupNumber) => Number(groupNumber));
    },
};

export function lineGroupFilter(state = defaultStateOfLineGroupFilter, action) {
    state = {...state};

    if (action.type === Const.SET_LINE_GROUPS) {
        state.lineGroups = action.lineGroups;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state.lineGroups = defaultStateOfLineGroupFilter.lineGroups;
    }

    return state;
}

const defaultStateOfTiersFilter = createOverallFilterTier();

export function tiersFilter(state = defaultStateOfTiersFilter, action) {
    if (action.type === Const.SET_PLAYER_TIERS_FILTER) {
        state = action.tier;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = createOverallFilterTier();
    }

    return state;
}

export function flexMaxExposurePositions(state = {}, action) {
    if (action.type === Const.SET_FLEX_MAX_EXPOSURE_POSITION) {
        return {...state, ...action.data};
    // } else if (inArray(action.type, [Const.RESET_FLEX_MAX_EXPOSURE_POSITION, Const.RESET_ALL_SETTINGS])) {
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        return {};
    }

    return state;
}

export function superFlexMaxExposurePositions(state = {}, action) {
    if (action.type === Const.SET_SUPERFLEX_MAX_EXPOSURE_POSITION) {
        return {...state, ...action.data};
    // } else if (inArray(action.type, [Const.RESET_SUPERFLEX_MAX_EXPOSURE_POSITION, Const.RESET_ALL_SETTINGS])) {
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        return {};
    }

    return state;
}

const defaultPlayersData = {
    players: {},
    playersCount: 0,
    lockedCount: 0,
    lockedSalary: 0,
    totalExcludedQnt: 0,
    excludedByMode: {},
};

const defaultStateOfPlayers = {
    data: defaultPlayersData,
    loading: false,
    playersGroupReady: false,
    all() {
        return {...this.data.players};
    },
    getAllAsArr() {
        return Object.values(this.data.players);
    },
    getAllNotExcludedAsArr() {
        return Object.values(this.data.players).filter((player) => !player.isExcludedAnywhere());
    },
    getPlayersByGameInfo(gameInfo) {
        return Object.values(this.data.players).filter((player) => player.gameInfo === gameInfo);
    },
    getPlayer(playerId) {
        const data = this.all();

        return data[this.doIndex(playerId)] ?? null;
    },
    hasPlayers() {
        return !isEmpty(this.all());
    },
    doIndex(playerId) {
        return 'player-' + playerId;
    },
    isLoading() {
        return this.loading;
    },
    isPlayersGroupReady() {
        return this.playersGroupReady;
    },
    getSwapOptions(substitutablePlayer, games, lineupPlayerIds, playersFilter, sportConfig) {
        let players = Object.values(this.data.players);
        let playerMode = Const.FLEX_MODE;
        const specialRoles = [Const.CAPTAIN_MODE, Const.STAR_MODE, Const.PRO_MODE, Const.FLEX_MODE];
        const isSportWithoutTeams = inArray(sportConfig.getSport(), [
            Const.LEAGUE_F1,
            Const.LEAGUE_GOLF,
            Const.LEAGUE_MMA,
            Const.LEAGUE_NASCAR,
            Const.LEAGUE_TENNIS,
        ]);

        if (specialRoles.includes(substitutablePlayer.lineupRole)) {
            players = SubstitutePlayersConverter.convertToMode(players, substitutablePlayer.lineupRole);
            playerMode = substitutablePlayer.lineupRole;
        } else if (sportConfig.isSportF1() || sportConfig.isSportLol()) {
            const mode = substitutablePlayer.lineupRole === Const.CAPTAIN_MODE ? Const.CAPTAIN_MODE : Const.FLEX_MODE;
            players = SubstitutePlayersConverter.convertToMode(players, mode);
        }

        return players.filter((substitutePlayer) => {
            const isNotDuplicate = !substitutePlayer.isDuplicate(lineupPlayerIds);
            const isTeamFit = isSportWithoutTeams || inArray(substitutePlayer.team, playersFilter.games);
            const isPlayerNotExcludedByMode = !substitutePlayer.isExcludedByMode(playerMode);
            const isPlayerGameLocked = !games.isPlayerGameLocked(substitutePlayer);
            const isPlayerFit = substitutePlayer.isFitForLineup(substitutablePlayer);

            return isNotDuplicate && isTeamFit && isPlayerNotExcludedByMode && isPlayerGameLocked && isPlayerFit;
        });
    },
};

export function players(state = defaultStateOfPlayers, action) {
    state = {...state};

    if (action.type === Const.GET_SLATE_REQUEST) {
        state.loading = true;
    } else if (action.type === Const.SET_IS_PLAYERS_GROUP_READY) {
        state.playersGroupReady = action.value;
    } else if (action.type === Const.GET_PLAYERS_SUCCESS) {
        const {players, modificationType = Const.PLAYERS_MODIFICATION_TYPE_SET} = action.data;

        if (modificationType === Const.PLAYERS_MODIFICATION_TYPE_MERGE) {
            state.data.players = {...state.data.players, ...players};
        } else {
            state.data.players = players;
        }

        state.loading = false;
    } else if (action.type === Const.DELETE_PLAYERS_BY_IDS) {
        const {playerIds} = action.data;
        Object.values(playerIds).map((playerId) => {
            delete state.data.players[state.doIndex(playerId)];
        });
    } else if (action.type === Const.GET_SLATE_FAILURE) {
        state = {...state, data: defaultPlayersData, loading: false, error: action.error};
    } else if (action.type === Const.UNSET_PLAYERS) {
        state.data.players = {};
        state.loading = false;
    } else if (action.type === Const.EXCLUDE_PLAYERS_NOT_IN_ORDER_RANGE) {
        const priorities = Object.keys(action.order)
            .filter((priority) => !action.order[priority])
            .map((priority) => Number(priority));

        Object.values(state.data.players).map((player) => {
            if (inArray(player.order, priorities) && !player.isPitcher()) {
                player.excludeBy([Const.EXCLUDED_BY_ORDER_RANGE]);
            } else if (player.isExcludedBy(Const.EXCLUDED_BY_ORDER_RANGE)) {
                player.includeBy([Const.EXCLUDED_BY_ORDER_RANGE]);

                !player.isExcludedByFilter() && player.include();
            }
        });
    } else if (action.type === Const.EXCLUDE_PLAYERS_NOT_IN_CONFIRMED_RANGE) {
        Object.values(state.data.players).map((player) => {
            if (action.confirmed !== Const.PLAYERS_CONFIRMED_FILTER_ALL && action.confirmed != player.confirmed) {
                player.excludeBy([Const.EXCLUDED_BY_CONFIRMED_RANGE]);
            } else if (player.isExcludedBy(Const.EXCLUDED_BY_CONFIRMED_RANGE)) {
                player.includeBy([Const.EXCLUDED_BY_CONFIRMED_RANGE]);

                !player.isExcludedByFilter() && player.include();
            }
        });
    } else if (action.type === Const.EXCLUDE_PLAYERS_NOT_IN_LINE_GROUPS) {
        const lineGroups = Object.keys(action.lineGroups)
            .filter((groupNumber) => !action.lineGroups[groupNumber])
            .map((groupNumber) => Number(groupNumber));

        Object.values(state.data.players).map((player) => {
            if (inArray(player.userLineGroup, lineGroups) && !player.isGoalie()) {
                player.excludeBy([Const.EXCLUDED_BY_LINE_GROUPS_RANGE]);
            } else if (player.isExcludedBy(Const.EXCLUDED_BY_LINE_GROUPS_RANGE)) {
                player.includeBy([Const.EXCLUDED_BY_LINE_GROUPS_RANGE]);

                !player.isExcludedByFilter() && player.include();
            }
        });
    } else if (action.type === Const.RESET_EXCLUDE_PLAYERS_BY_RANGE) {
        Object.values(state.data.players).map((player) => player.include());
    } else if (action.type === Const.LOCKING_SET_PLAYERS) {
        Object.keys(action.items).map((mode) => {
            Object.keys(action.items[mode]).map((playerId) => {
                const player = state.getPlayer(playerId);
                if (player && Boolean(action.items[mode][playerId])) {
                    player.include();
                }
            });
        });
    } else if (action.type === Const.UPDATE_PLAYER_PARAMS) {
        for (let key in action.data) {
            const {playerId, ...rest} = action.data[key];
            const player = state.getPlayer(playerId);
            if (typeof player !== 'undefined') {
                state.data.players[state.doIndex(playerId)] = {...player, ...rest};
            }
        }
    } else if (action.type === Const.RESET_PP_LINE) {
        Object.values(state.data.players).map((player) => player.resetPPLine());
    } else if (action.type === Const.RESET_PLAYERS_LINE_GROUPS) {
        Object.values(state.data.players).map((player) => player.resetLineGroups());
    } else if (action.type === Const.SET_DOMINATOR) {
        for (let key in action.dominators) {
            const {playerId, ...rest} = action.dominators[key];
            const player = state.getPlayer(playerId);
            if (typeof player !== 'undefined') {
                state.data.players[state.doIndex(playerId)] = {...player, ...rest};
            }
        }
    } else if (action.type === Const.SET_PLAYERS_LINE_GROUP) {
        for (let key in action.data) {
            const {playerId, ...rest} = action.data[key];
            const player = state.getPlayer(playerId);
            if (typeof player !== 'undefined') {
                state.data.players[state.doIndex(playerId)] = {...player, ...rest};
            }
        }
    } else if (action.type === Const.SET_PLAYERS_PP_LINE) {
        for (let key in action.data) {
            const {playerId, ...rest} = action.data[key];
            const player = state.getPlayer(playerId);
            if (typeof player !== 'undefined') {
                state.data.players[state.doIndex(playerId)] = {...player, ...rest};
            }
        }
    } else if (action.type === Const.SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_CSV) {
        Object.keys(action.data).map((playerId) => {
            const player = state.getPlayer(playerId);

            player && player.projOwn.setValueFromCsv(action.data[playerId]);
        });
    } else if (action.type === Const.SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_STORAGE) {
        Object.keys(action.data).map((playerId) => {
            const player = state.getPlayer(playerId);

            player && player.projOwn.setValueFromStorage(action.data[playerId]);
        });
    } else if (action.type === Const.SET_PLAYERS_POINTS) {
        const {mode, items, manually} = action;
        Object.values(items).map((item) => {
            const {playerId, userPoints} = item;
            const player = state.getPlayer(playerId);

            if (!player) {
                return;
            }

            if (typeof manually === 'boolean') {
                player.setModePropValue(mode, 'userPoints', userPoints);
                player.setModePropValue(mode, 'pointsChangedManually', action.manually);
            } else if (typeof manually === 'object') {
                player.setModePropValue(mode, 'pointsChangedManually', inArray(playerId, action.manually));
                if (inArray(playerId, action.manually)) {
                    player.setModePropValue(mode, 'userPoints', userPoints);
                }
            } else {
                player.setModePropValue(mode, 'userPoints', userPoints);
            }
        });
    } else if (action.type === Const.SET_PLAYERS_SCORES) {
        const {mode, items} = action;

        Object.values(items).map((item) => {
            const {playerId, userPoints} = item;
            const player = state.getPlayer(playerId);

            if (!player) {
                return;
            }

            const userScore = calcUserScore(
                userPoints,
                player.getPropValueOfMode('salary', mode),
                player.userScoreMultiplier,
            );

            player.setModePropValue(mode, 'userScore', userScore);
        });
    } else if (action.type === Const.SET_PLAYERS_EXPOSURE) {
        Object.values(action.data).map((item) => {
            const {playerId, exposureMin = null, exposureMax = null, mode = Const.DEFAULT_MODE} = item;
            const player = state.getPlayer(playerId);

            if (!player) {
                return;
            }

            exposureMin !== null && player.setModePropValue(mode, 'exposureMin', exposureMin);
            exposureMax !== null && player.setModePropValue(mode, 'exposureMax', exposureMax);
        });
    } else if (action.type === Const.SET_PLAYERS_COUNTERS) {
        state.data = {...state.data, ...action.counters};
    } else if (action.type === Const.CHANGE_PLAYERS_POSITION) {
        const {payload} = action;

        Object.values(payload).map((item) => {
            const {playerId, positionSlug} = item;
            const player = state.getPlayer(playerId);

            if (isEmpty(player)) {
                return;
            }

            const isPositionPresent =
                player.hasOwnProperty('selectablePositionsMap') &&
                player.selectablePositionsMap.hasOwnProperty(positionSlug);

            if (isPositionPresent) {
                player.positionName = positionSlug;
                player.position = player.selectablePositionsMap[positionSlug];
                player.positionShortNames = positionSlug.split('/').map((value) => value.trim());
            }
        });
    } else if (action.type === Const.RESET_ALL_SETTINGS) {
        Object.values(state.data.players).map((player) => {
            player.resetExposure();

            if (player.hasOwnProperty('originalPosition')) {
                player.positionName = player.originalPosition.slug;
                player.position = player.originalPosition.numbers;
            }
            if (typeof player.resetDominator === 'function') {
                player.resetDominator();
            }
            if ('projOwn' in player && typeof player.projOwn.resetValue === 'function') {
                player.projOwn.resetValue();
            }
        });
    }

    return state;
}

export function preparedPlayers(state = {}, action) {
    if (action.type === Const.SET_PREPARED_PLAYERS_LIST) {
        return {...state, ...action.data};
    }

    return state;
}

const defaultStateOfGames = {
    data: {},
    loaded: false,
    loading: false,
    isLoading() {
        return this.loading;
    },
    isLoaded() {
        return this.loaded;
    },
    getAllAsArr() {
        return Object.values(this.data);
    },
    getAllIndexedByGameInfo() {
        return {...this.data};
    },
    getAllInactive() {
        return this.getAllAsArr().filter((game) => !game.isActive);
    },
    hasMoreThanOneGame() {
        return !this.isLoading() && this.getGamesQuantity() > 1;
    },
    hasGames() {
        return !isEmpty(this.data);
    },
    getGamesQuantity() {
        return this.getAllAsArr().length;
    },
    getGameByPlayer(player) {
        return this.data?.[player.gameInfo] ?? null;
    },
    getGameByTeamName(teamName) {
        teamName = teamName.toUpperCase();

        for (let game of this.getAllAsArr()) {
            if (game.teams.hasOwnProperty(teamName)) {
                return {...game};
            }
        }

        return null;
    },
    isPlayerGameLocked(player) {
        const game = this.getGameByPlayer(player);

        return !isEmpty(game) && game.isLocked;
    },
    isTeamGameLocked(teamName) {
        const game = this.getGameByTeamName(teamName);

        return !isEmpty(game) && game.isLocked;
    },
    isPlayerGameInactive(player) {
        const game = this.getGameByPlayer(player);

        return !isEmpty(game) && !game.isActive;
    },
};

export function games(state = defaultStateOfGames, action) {
    if (action.type === Const.GET_SLATE_REQUEST) {
        state = {...state, loading: true, loaded: false};
    } else if (action.type === Const.GET_GAMES_SUCCESS) {
        state = {...state, data: indexArray(action.data, 'gameInfo'), loading: false, loaded: true};
    } else if (action.type === Const.GET_SLATE_FAILURE) {
        state = {...state, data: {}, loading: false, loaded: true, error: action.error};
    } else if (
        inArray(action.type, [
            Const.FILTER_BY_MODE,
            Const.FILTER_BY_SITE,
            Const.FILTER_BY_SPORT,
            Const.FILTER_BY_GAME_TYPE,
            Const.FILTER_BY_SLATE,
        ])
    ) {
        state = {...state, data: {}, loading: false, loaded: false};
    }

    return state;
}

const defaultStateOfTeams = {
    data: {},
    all() {
        return {...this.data};
    },
};

export function teams(state = defaultStateOfTeams, action) {
    if (action.type === Const.SET_TEAM_DETAILS) {
        return {...state, data: action.data};
    } else if (action.type === Const.UNSET_TEAM_DETAILS) {
        return {...state, data: {}};
    }

    return state;
}

const defaultStateOfSlates = {
    data: {},
    getAsSortedArr(sortedBy, direction = 'asc') {
        const slates = Object.values(this.data);
        slates.sort(sortByProperty(sortedBy, direction));
        return [...slates];
    },
    hasItems() {
        return !isEmpty(this.data);
    },
    isReady() {
        return !this.error && this.hasItems();
    },
    getById(id) {
        id = Number(id);
        if (this.data.hasOwnProperty(id)) {
            return {...this.data[id]};
        }
        return {};
    },
    error: false,
    loading: false,
    isLoading() {
        return this.loading;
    },
};

export function slates(state = defaultStateOfSlates, action) {
    if (action.type === Const.GET_SLATES_REQUEST) {
        state = {...state, loading: true, error: false};
    } else if (action.type === Const.GET_SLATES_SUCCESS) {
        const data = indexArray(action.data, 'id');
        state = {...state, data, loading: false, error: false};
    } else if (action.type === Const.UPDATE_SLATE) {
        const {data} = state;
        data[action.data.id] = action.data;
        state = {...state, data, loading: false, error: false};
    } else if (action.type === Const.GET_SLATES_FAILURE) {
        state = {...state, loading: false, error: action.error};
    } else if (action.type === Const.UNSET_SLATES) {
        state = {...state, data: {}, loading: false, error: false};
    }

    return state;
}

// export function randomPoints(state = {items: {}}, action) {
//     state = {...state};

//     if (action.type === Const.SET_RANDOM_POINTS) {
//         state.items[action.lineupNumber] = {...action.points};
//     } else if (action.type === Const.UNSET_RANDOM_POINTS) {
//         state.items = {};
//     }

//     return state;
// }

const reducers = {
    filters,
    mlbFilters,
    lineGroupFilter,
    tiersFilter,
    flexMaxExposurePositions,
    superFlexMaxExposurePositions,
    players,
    preparedPlayers,
    games,
    teams,
    slates,
    // randomPoints,
};

export default combineReducers(reducers);
